const menuOpenButton = document.querySelector(".openmenu");
const menuCloseButton = document.querySelector(".menu-close-button");
const mobileMenuDropdown = document.querySelector(".mobile-menu-dropdown");
const topMenu = document.querySelectorAll("#menu-primary-mega-menu").childNodes;
const darkOverlay = document.querySelector(".dark_overlay");

// const topSearchBar = document.querySelector("#topSearchBar");
const searchbarCloseButton = document.querySelector(
  ".sub-menu .searchbar-close-button"
);
// Select both menus using a comma-separated selector
var menus = document.querySelectorAll("#desktopNav, #desktopSecondNav");
//var menuItemWithChildren = desktopMenu.querySelectorAll(".menu-item-has-children");
var searchFormBlock = document.querySelector("#search_form_block");


var goBackEl = document.createElement("div");
goBackEl.classList.add( "btn", "btn-back");
goBackEl.innerHTML = "Back";



function toggleMenu(el, className) {
  //if (el.classList.contains(className)) {
    el.classList.remove(className);
 // }
}

// document.addEventListener("click", function (event) {
//   if (!event.target.closest(".menu-item-has-children")) {
//       closeAllSubMenus();
//   }
// });


function closeAllSubMenus(){
  //var subMenu =  topMenu;
  document.body.classList.remove("deactivatescroll");
  darkOverlay.classList.remove("active");

  document.querySelectorAll(".desktop_sub_menu_active").forEach(subMenu => {
    subMenu.classList.remove("desktop_sub_menu_active");
});

document.querySelectorAll(".show_desktop_child").forEach(subMenu => {
  subMenu.classList.remove("show_desktop_child");
});
return true;
}


function subMenuClickFunction() {
  var subMenu = this.querySelector(".sub-menu");
  //var showDesktopChild = subMenuParent.classlist.contains('show_desktop_child');
  //console.log(showDesktopChild);

  var hasShowDesktopChild = false;
  var parentElement = this; // Start from the clicked element

  while (parentElement) {
      if (parentElement.classList && parentElement.classList.contains("show-child")) {
          hasShowDesktopChild = true;
          break; // Stop checking once we find a valid parent
      }
      parentElement = parentElement.parentElement;
  }

  if(hasShowDesktopChild){
    return;
  }

  // if (subMenu !== null) {
      subMenu.classList.add("desktop_sub_menu_active");
      // Find the first child of subMenu that has both 'show-child' and 'no-sub-wrap' classes
      var targetChild = subMenu.querySelector(".show-child");

      if (targetChild) {
          // Ensure the "Back" button is added only once
          if (!targetChild.firstChild || !targetChild.firstChild.classList.contains("btn-back")) {
              console.log("Adding Back button to:", targetChild);
              var backButton = document.createElement("div");
              backButton.classList.add("btn", "btn-back");
              backButton.innerHTML = "Back";
              backButton.addEventListener("click", subMenuBack);

              // Insert as the first child of the target element
              targetChild.insertBefore(backButton, targetChild.firstChild);
          }
      }
  //}
}




function subMenuBack(e) {
  var subMenu = e.target.closest(".desktop_sub_menu_active");
 

    if (subMenu != null) {
          setTimeout(function () {
            //subWrapper.classList.remove('show-mobile-sub-menu'); // hide the submenu
            subMenu.classList.remove("desktop_sub_menu_active"); // hide the submenu
          }, 10);
   }
  
}

function subMenuFirst(e) {
  
 var subMenu = e.children;
 //ar subMenuChildren = this.querySelectorAll('.show_desktop_child');
 for (var i = 0, l = subMenu.length; ++i < l;) {
  var subMenuItem = subMenu[i];
  //closeAllSubMenus();
  if(subMenuItem.classList.contains('show_desktop_child')){
    //setTimeout(() => {closeAllSubMenus(), 500});

    subMenuItem.classList.remove("show_desktop_child");
     document.body.classList.remove("deactivatescroll");
    darkOverlay.classList.remove("active");
 
    // closeAllSubMenus();
  }else{
    closeAllSubMenus();
    document.body.classList.add("deactivatescroll");
    darkOverlay.classList.add("active");
    subMenuItem.classList.add("show_desktop_child");
  }
  //var showDesktopChild = subMenuItem.querySelector('.sub-menu');
  //console.log(subMenuItem.querySelector('.show_desktop_child'));

}


}

// function subMenuFirstClose(e) {
//   var subMenu = e.children;
//   //ar subMenuChildren = this.querySelectorAll('.show_desktop_child');
//   // for (var i = -1, l = subMenu.length; ++i < l;) {
//   //  var subMenuItem = subMenu[i];
 
//   //  if(subMenuItem.classList.contains('show_desktop_child')){
//   //    subMenuItem.classList.remove("show_desktop_child");
//   //  }else{
//   //    subMenuItem.classList.add("show_desktop_child");
//   //  }
// // }
// }

// goBackEl.addEventListener("click", subMenuBack);


darkOverlay.addEventListener("click", () => {
  setTimeout(() => {closeAllSubMenus(), 500});
  setTimeout(() => {toggleMenu(), 500});
});




menus.forEach((desktopMenu) => {
  if (!desktopMenu) return; // Safety check

  var menuItemWithChildren = desktopMenu.querySelectorAll(".menu-item-has-children");
  menuItemWithChildren.forEach((item) => {
    // List of allowed parent IDs
    const allowedParents = [
      "menu-primary-mega-menu", 
      "menu-freedspace-menu", 
      "menu-tracklab-menu", 
      "menu-scanlab-menu"
    ];

    if (allowedParents.includes(item.parentElement.id)) {
      var navLink = item.querySelector(".nav-link");

      if (navLink) {
        navLink.addEventListener("click", (e) => {
          // If you want to prevent the default link behavior on click:
          // e.preventDefault(); 
          subMenuFirst(item);
        });
      }

      // Drilling down to the third-level items
      item.childNodes.forEach(function (childrenItems) {
        childrenItems.childNodes.forEach(function (childrenThirdItems) {
          // Check if it's an element node before adding listener
          if (childrenThirdItems.nodeType === 1) {
            childrenThirdItems.addEventListener("click", subMenuClickFunction);
          }
        });
      });
    }
  });


// menuItemWithChildren.forEach((item) => {
//   // Desktop Menu



//   if (desktopMenu != null) {


//     // desktopMenu.addEventListener("mouseout", () => {
//     //   var subMenu = item;
//     //   closeAllSubMenus();
//     //   //subMenuFirst(subMenu);
//     // });

//     if (item.parentElement.id === "menu-primary-mega-menu" || item.parentElement.id === "menu-freedspace-menu"  || item.parentElement.id === "menu-tracklab-menu" || item.parentElement.id === "menu-scanlab-menu") {
//       // check for desktop menu

//       var navLink = item.querySelector(".nav-link");
      
//       navLink.addEventListener("click", () => {
//         var subMenu = item;
//         // closeAllSubMenus();
//         subMenuFirst(subMenu);
//       });

//       // item.addEventListener("mouseout", () => {
//       //   var subMenu = item;
//       //   subMenuFirstClose(item);
//       // });


//       item.childNodes.forEach(function (childrenItems) {
      
//         childrenItems.childNodes.forEach(function (childrenThirdItems) {
         
//           childrenThirdItems.addEventListener("click", subMenuClickFunction);
        
//         });
//       });

//       // item.addEventListener("click", (event) => {
//       //   //console.log(item.querySelector(".sub-menu"));
//       //   var subMenu = event.target.querySelector(".sub-menu");

//       //   //var subMenu = subChildNode.querySelector(".sub-menu");
//       //   console.log(event);
//       //   if (subMenu != null) {
//       //     subMenu.classList.add("desktop_sub_menu_active");
//       //     console.log("enter");
//       //   }
//       // });

//       // item.addEventListener("click", (event) => {
//       //   var subChildNode = event.target.querySelector(".sub-menu");
//       //   subChildNode.classList.remove("childrenDisplay");
//       //   console.log("leave");
//       // });
//     }
//   }


    // Initialize event listeners
    //attachEventListeners();
    // observeDynamicMenus();
    // document.addEventListener("click", closeOnClickOutside);
    // document.addEventListener("keydown", closeOnEscapeKey);

addEventListener("resize", (event) => { })

onresize = (event) => {
 setTimeout(() => {closeAllSubMenus(), 500});
  // setTimeout(() => {toggleMenu(), 500});
 }

});

